import React from 'react';
import { RadioInputTemplateProps } from '../../..';

export const RadioInputContentTemplate = (props: RadioInputTemplateProps) => {
  return (
    <div>
      <input
        id={props.id}
        type="hidden"
        name={props.name}
        value={props.checked ? 'on' : 'off'}
        data-clean={props['data-clean']}
        data-blurred={props['data-blurred']}
        data-valid={props['data-valid']}
        onChange={() => ({})}
      />
      <div
        onClick={(e) => {
          props.onClick(e);
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
